export const colors = {
    fire: "#FDDFDF",
    grass: "#DEFDE0",
    electric: "#FCF7DE",
    water: "#DEF3FD",
    dark: "#83756C",
    ghost: "#7F7FC1",
    ice: "#B5EBFD",
    ground: "#f4e7da",
    rock: "#d5d5d4",
    fairy: "#fceaff",
    steel: "#C3C3CF",
    poison: "#98d7a5",
    bug: "#f8d5a3",
    dragon: "#97b3e6",
    psychic: "#eaeda1",
    flying: "#F5F5F5",
    fighting: "#E6E0D4",
    normal: "#F5F5F5",
};